<mat-toolbar mat-dialog-title data-testid="confirm-delete-dialog-title">
  {{ (data.title || 'confirm_delete_tr') | translate }}
</mat-toolbar>

<mat-dialog-content style="padding: 1em 1em">
  @if (data.message) {
    {{ data.message | translate }}
  } @else {
    {{ 'continue_delete_tr' | translate }} {{ data.type }}
    <strong>{{ data.name }}</strong>
    ?
  }
</mat-dialog-content>

<dialog-form-actions>
  @if (data.title) {
    <button type="button" data-testid="cancel-delete-action" [mat-dialog-close]="false" mat-raised-button>
      {{ 'cancel_tr' | translate }}
    </button>
    <button type="button" data-testid="confirm-delete-action" [mat-dialog-close]="true" [color]="data.confirmColor || 'warn'" mat-raised-button>
      {{ (data.confirmLabel || 'Delete_tr') | translate }}
    </button>
  } @else {
    <button type="button" data-testid="confirm-delete-action" [mat-dialog-close]="true" [color]="data.confirmColor || 'warn'" mat-raised-button>
      {{ (data.confirmLabel || 'Delete_tr') | translate }}
    </button>
    <button type="button" data-testid="cancel-delete-action" [mat-dialog-close]="false" mat-raised-button>
      {{ 'cancel_tr' | translate }}
    </button>
  }
</dialog-form-actions>
